import { Lightning, Utils } from "@lightningjs/sdk";
import { GlassSurface } from "./GlassSurface";
import { gameLogo } from "./gameLogo";
export class ScoreBanner extends Lightning.Component {
    static _template() {
        const label = {
            fontFace: "Insatiable Display",
            fontStyle: "700",
            fontSize: 24,
            precision: 1,
            h: 31,
            lineHeight: 31,
            offsetY: 24,
            textColor: 0xffffffff,
            wordWrap: false,
        };
        const score = Object.assign(Object.assign({}, label), { w: 121, h: 121, fontSize: 94, lineHeight: 121, offsetY: 95, textAlign: "center" });
        const divider = {
            w: 1.8,
            h: 31,
            texture: Lightning.Tools.getSvgTexture(Utils.asset("images/hero/info-divider.svg"), 4, 62),
            flexItem: { marginLeft: 15.1, marginRight: 15.1 },
        };
        const team = {
            w: 149,
            h: 149,
            Logo: { y: 0.317, w: 149, h: 149 },
            Name: {
                x: 74.5,
                y: 150.317,
                mountX: 0.5,
                text: {
                    fontFace: "Roboto",
                    fontStyle: "400",
                    fontSize: 24,
                    precision: 1,
                    h: 31,
                    lineHeight: 31,
                    offsetY: 24,
                    textColor: 0xffffffff,
                    textAlign: "center",
                    wordWrap: false,
                },
            },
        };
        return {
            w: this.W,
            h: this.H,
            Background: {
                type: GlassSurface,
                w: (w) => w,
                h: (h) => h,
                glassOptions: {
                    // Figma Score Banner (2023:91985). Its GLASS effect is approximated
                    // with a curved bezel; these are not Figma's internal equations.
                    radius: 16.393,
                    bezelWidth: 25.273,
                    thickness: 25.273,
                    refraction: 0.8,
                    blur: 14.344,
                    dispersion: 0.5,
                    lightAngle: -45,
                    lightIntensity: 0.8,
                    rimWidth: 1.3,
                    rimOpacity: 0.2,
                },
            },
            Score: {
                x: this.W / 2,
                y: 17.3,
                h: 199,
                mountX: 0.5,
                flex: { direction: "row", alignItems: "center" },
                HomeTeam: team,
                HomeScore: { w: 121, h: 121, text: score },
                Divider: {
                    w: 1.67857,
                    h: 90,
                    texture: Lightning.Tools.getSvgTexture(Utils.asset("images/hero/score-divider.svg"), 4, 180),
                    flexItem: { marginLeft: 15.160715, marginRight: 15.160715 },
                },
                AwayScore: { w: 121, h: 121, text: score },
                AwayTeam: team,
            },
            Info: {
                x: this.W / 2,
                y: 224.3,
                mountX: 0.5,
                flex: { direction: "row", alignItems: "center", padding: 18 },
                Round: { text: label },
                DateDivider: divider,
                Date: { text: label },
                VenueDivider: divider,
                Venue: { text: label },
            },
            Status: {
                x: this.W / 2,
                y: -14.7,
                w: 183.221,
                h: 32.221,
                mountX: 0.5,
                flex: {
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "center",
                },
                Background: {
                    w: (w) => w,
                    h: (h) => h,
                    flexItem: false,
                    rect: true,
                    shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
                },
                Content: {
                    flexItem: { marginLeft: 16, marginRight: 16, shrink: 0 },
                    flex: { direction: "row", alignItems: "center" },
                    LiveIcon: {
                        w: 14,
                        h: 14,
                        texture: Lightning.Tools.getSvgTexture(Utils.asset("images/hero/live.svg"), 28, 28),
                        flexItem: { marginRight: 6 },
                    },
                    Label: {
                        text: Object.assign(Object.assign({}, label), { fontSize: 20, h: 26, lineHeight: 26, offsetY: 20.5, textColor: 0xff161616 }),
                    },
                },
            },
        };
    }
    set item(item) {
        var _a, _b, _c, _d, _e, _f, _g;
        this._stopCountdown();
        this._startsAt = item.live ? undefined : item.startsAt;
        const hasScores = item.homeScore !== undefined && item.awayScore !== undefined;
        // Upcoming matches leave more room between the full club names.
        const dividerMargin = hasScores ? 15.160715 : 39.160715;
        const homeLogoWidth = (_a = item.homeLogoWidth) !== null && _a !== void 0 ? _a : 149;
        const awayLogoWidth = (_b = item.awayLogoWidth) !== null && _b !== void 0 ? _b : 149;
        const awayLogoHeight = (_c = item.awayLogoHeight) !== null && _c !== void 0 ? _c : 149;
        const scoreFontSize = Math.max((_d = item.homeScore) !== null && _d !== void 0 ? _d : 0, (_e = item.awayScore) !== null && _e !== void 0 ? _e : 0) >= 100 ? 72 : 94;
        this.patch({
            Score: {
                HomeTeam: {
                    Logo: Object.assign(Object.assign({}, gameLogo(item.homeLogoSrc, homeLogoWidth, 149)), { x: (149 - homeLogoWidth) / 2, w: homeLogoWidth }),
                    Name: {
                        text: {
                            text: item.homeName,
                            fontFace: hasScores ? "Roboto" : "Lato",
                        },
                    },
                },
                HomeScore: {
                    visible: hasScores,
                    text: { text: String((_f = item.homeScore) !== null && _f !== void 0 ? _f : ""), fontSize: scoreFontSize },
                },
                AwayScore: {
                    visible: hasScores,
                    text: { text: String((_g = item.awayScore) !== null && _g !== void 0 ? _g : ""), fontSize: scoreFontSize },
                },
                AwayTeam: {
                    Logo: Object.assign(Object.assign({}, gameLogo(item.awayLogoSrc, awayLogoWidth, awayLogoHeight)), { x: (149 - awayLogoWidth) / 2, y: 0.317 + (149 - awayLogoHeight) / 2, w: awayLogoWidth, h: awayLogoHeight }),
                    Name: {
                        text: {
                            text: item.awayName,
                            fontFace: hasScores ? "Roboto" : "Lato",
                        },
                    },
                },
                Divider: {
                    flexItem: { marginLeft: dividerMargin, marginRight: dividerMargin },
                },
            },
            Info: {
                Round: { text: { text: item.round } },
                Date: { text: { text: item.date } },
                Venue: { text: { text: item.venue } },
            },
            Status: {
                // Widest label at 28px is "STARTS IN 00:00:00": ceil(196.224) + 32px padding.
                w: item.live ? 183.221 : 229,
                y: item.live ? -14.7 : -19.883,
                h: 40,
                Background: { color: item.live ? 0xfffe80e0 : 0xff085fff },
                Content: {
                    LiveIcon: { visible: !!item.live },
                    Label: {
                        text: {
                            text: item.live ? "LIVE" : "UPCOMING",
                            textColor: item.live ? 0xff161616 : 0xfffe80e0,
                            fontSize: 28,
                            h: 36,
                            lineHeight: 36,
                            offsetY: item.live ? 28 : 30,
                        },
                    },
                },
            },
        });
        this._updateCountdown();
        if (this.active)
            this._startCountdown();
    }
    _active() {
        this._updateCountdown();
        this._startCountdown();
    }
    _inactive() {
        this._stopCountdown();
    }
    _detach() {
        this._stopCountdown();
    }
    _startCountdown() {
        this._stopCountdown();
        if (this._startsAt !== undefined && this._startsAt > Date.now()) {
            this._countdownTimer = setInterval(() => this._updateCountdown(), 1000);
        }
    }
    _stopCountdown() {
        clearInterval(this._countdownTimer);
        this._countdownTimer = undefined;
    }
    _updateCountdown() {
        if (this._startsAt === undefined)
            return;
        // Derive elapsed time from the clock so hidden/throttled views catch up.
        const remaining = Math.max(0, Math.ceil((this._startsAt - Date.now()) / 1000));
        const time = [
            Math.floor(remaining / 3600),
            Math.floor((remaining % 3600) / 60),
            remaining % 60,
        ]
            .map((part) => String(part).padStart(2, "0"))
            .join(":");
        this.tag("Status.Content.Label").patch({
            text: { text: `STARTS IN ${time}` },
        });
        if (remaining === 0)
            this._stopCountdown();
    }
}
ScoreBanner.W = 634.966;
ScoreBanner.H = 308.6;
export default ScoreBanner;
//# sourceMappingURL=ScoreBanner.js.map